/** @module Specification/BOM/SupplierAttributeMatrixClass */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/table/matrix/Path",
	"csi/xml",
], function(declare, _, Path, xml) {

	return declare(Path, {

		// C8-9944 Removes BOMSupplierAttributeMatrix heading filters
		restrictQuery: true,

		_getColumnNodes: function(/*Context*/ctx, /*Heading*/h) {
			var selectedSuppliers = ctx.view.selectedProductSuppliers;
			if (!selectedSuppliers)
				return [];

			var suppliersNodes = ctx.cache.getNodes(selectedSuppliers);
			suppliersNodes = _.sortBy(suppliersNodes, xml.ATTR_NAME);
			return suppliersNodes;
		},

		_getRowNodes: function(/*Context*/ctx, /*QueryResult*/qr, /*Spec*/spec, /*Node*/ node) {
			// responseSupplierAttrs is set when a new PartMaterials is created. In that case, this attribute will hold those
			// BOMSupplierAttributes created for that PartMaterial.
			var responseSupplierAttrs = ctx.view.get("responseSupplierAttributes");

			var columnProducrSource = ctx.cache.getNode(spec.columnUrl);
			if (null == columnProducrSource)
				return [];

			// ctx.cache.bomSupplierAttributes is populated by PartMaterial._extractBOMSupplierAttributes()
			var columnSupplierCnl = columnProducrSource.Supplier;
			var result;

			if (ctx.cache.bomSupplierAttributes) {
				result = ctx.cache.bomSupplierAttributes[columnSupplierCnl + ";" + node.$URL];
			}

			if (!result && responseSupplierAttrs) {
				// If the map doesn't have the SupplierAttribute for this PartMaterial, then we should check the nodes in response
				result = _.find(responseSupplierAttrs, function(url) {
					var responseSupplierAttr = ctx.cache.getNode(url);

					if (!responseSupplierAttr) {
						return false;
					}

					var responseProductSource = ctx.cache.getNode(responseSupplierAttr.__Parent__);
					return responseProductSource.Supplier == columnSupplierCnl;
				});

				result = ctx.cache.getNode(result);
			}
			return [result];
		}
	});
});
